import React, { useState, useEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import LoadingBar from './ui/LoadingBar';
import MapView from './MapView';

import config from './../config';
import helpers from './../lib/helpers';

function FolkloreMap(props) {
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(false);
	const [informantsMapView, setInformantsMapView] = useState(null);
	const location = useLocation();

	useEffect(() => {
		setInformantsMapView(props.setView);
	}, [props.setView]);

	const history = useHistory();

	useEffect(() => {
		if (!data) {
			fetchData();
		}
	});

	useEffect(() => {
		fetchData();
	}, [props.searchParams])

	const fetchData = () => {
		if (loading == true) {
			return;
		}

		setLoading(true);
		setData(null);

		let urlParams = [];

		if (props.searchParams != '') {
			let params = helpers.parseSearchParams(props.searchParams);

			if (params.texti) {
				urlParams.push('folklore_text='+params.texti)
			}

			if (params.form) {
				urlParams.push('folklore_type='+params.form)
			}

			if (params.einstaklingur) { // einstaklingur
				urlParams.push('folklore_person_name='+params.einstaklingur)
			}

			if (params.heimildarmadur) { // heimildarmaður
				if (isNaN(parseInt(params.heimildarmadur))) {
					urlParams.push('folklore_informant_name='+params.heimildarmadur)
				}
				else {
					urlParams.push('folklore_informant='+params.heimildarmadur);
				}
			}

			if (params.heimildarmadur_kyn) { // kyn heimildarmanns
				urlParams.push('folklore_informant_gender='+params.heimildarmadur_kyn)
			}

			if (params.heimildarmadur_stadsetning) { // uppruni heimildarmanns
				urlParams.push('folklore_informant_location='+params.heimildarmadur_stadsetning)
			}

			if (params.skrasetjari) { // skrásetjari
				if (isNaN(parseInt(params.skrasetjari))) {
					urlParams.push('folklore_recorder_name='+params.skrasetjari);
				}
				else {
					urlParams.push('folklore_recorder='+params.skrasetjari);
				}
			}

			if (params.efnisord) { // efnisorð
				urlParams.push('folklore_keyword='+params.efnisord)
			}

			if (params.sagnagerd) { // sagnagerð
				urlParams.push('folklore_key='+params.sagnagerd)
			}

			if (params.sogustadir) { // flokkur
				urlParams.push('folklore_location='+params.sogustadir)
			}

			if (params.bok) { // bók / handrit
				urlParams.push('folklore_book='+params.bok)
			}

			if (params.flokkur) { // flokkur
				urlParams.push('folklore_category='+params.flokkur)
			}

			if (params.safn) { // safn
				urlParams.push('folklore_collection='+params.safn)
			}

			if (params.tungumal) {
				if (params.tungumal != 'oll') {
					urlParams.push('folklore_language='+params.tungumal)
				}
			}
			/*
			else {
				urlParams.push('folklore_language=is')
			}
			*/
		}

		urlParams.push('has_location=True');
		urlParams.push('simple=True');
		urlParams.push('folklore=True');
		urlParams.push('limit=8000');

		if (props.extraParams) {
			urlParams.push(props.extraParams);
		}

		helpers.fetch(config.apiRoot+'/api/locations/'+(props.informantsMap ? 'folklore_informants' : '')+'?'+urlParams.join('&'), (json) => {
				setData(json.results.map((item) => {
					return {
						id: item.id,
						label: item.name,
						latLng: [item.lat, item.lng],
						count: item.relation_count,
						popupContent: '<h4>'+item.name+'</h4>'+
							'<p>'+
							(item.relation_count ? item.relation_count+' '+window.l('sagnir á þessum stað')+'.</br><br/>' : '')+
							'<a href="'+helpers.routerUrls['location']+item.id+'">'+window.l('Nánar')+'</a><br/>'+
							'<a href="'+location.pathname+(helpers.updateSearchParams(props.searchParams || '', props.informantsMap ? {heimildarmadur_stadsetning: item.id} : {sogustadir: item.id}))+'">'+window.l('Bæta þessum stað við leit')+'</a></p>'
					}
				}));
				setLoading(false);

				if (props.onResponse) {
					props.onResponse(json.results);
				}
			});
	}

	return (
		<div className={'position-relative '+(props.className || '')+(loading ? ' loading' : '')}>
			<LoadingBar />
			<MapView setMapView={informantsMapView} forceSmallMarkers={true} mapData={data || []} onMoveEnd={(event) => {
				if (props.onMoveEnd) {
					props.onMoveEnd(event);
				}
			}} />
		</div>
	)
}

export default FolkloreMap;
